/**
 * Home
 */

import Vue from 'vue';

import Term from './components/Term';
import Nav from './components/_nav';

Nav.nav();

const app = new Vue({
  el: '#app-root',
  components: {
    'v-term': Term,
  },
});



// WEBPACK FOOTER //
// ./home.js